<template>
  <div
    class="d-flex justify-space-between align-center"
  >
    <div class="d-flex align-center">
      <div
        class="text-subtitle-2"
        :class="['font-weight-regular grey--text', { 'mb-2': !showPaywall }]"
      >
        <span class="font-italic">
          <span v-if="questionsRemaining === 1">
            1 Question Remaining
          </span>
          <span v-else>
            {{ questionsRemaining }} Questions Remaining
          </span>
        </span>
        <span
          v-if="autoRenewEnabled"
          :class="{ 'ml-2': !$isMobile }"
          class="text-caption primary-grey--text px-3 py-1 font-weight-regular font-italic"
        >
          <v-icon
            left
            small
          >
            mdi-refresh
          </v-icon>
          Auto-renews when you run out
        </span>
        <v-btn
          v-else-if="!showPaywall"
          depressed
          x-small
          class="text-none font-weight-bold px-2 py-1 ml-3 white--text"
          :color="COLORS.grainfoxAIButton"
          @click="$emit('buy-more-questions')"
        >
          <v-icon
            left
            small
          >
            mdi-arrow-up-circle-outline
          </v-icon>
          <span>
            Buy More
          </span>
        </v-btn>
      </div>
    </div>

    <div
      v-if="deepDiveEnabled"
      class="d-flex align-center"
    >
      <GOnboardingTooltip
        ref="onboardingTooltip"
        :value="showOnboardingTooltip"
        position="top-start"
        :background-color="COLORS.grainfoxAIButton"
        :style="tooltipStyle"
        use-close-icon
        title=""
        @ok="dismissOnboardingTooltip"
      >
        <template #title>
          <p class="text-body-2 font-weight-medium white--text mb-2">
            When you activate DEEP DIVE Sinoa will think longer to access richer, more comprehensive insights.
          </p>
        </template>

        <v-tooltip
          top
          :open-delay="2000"
          :color="COLORS.grainfoxAIButton"
          :disabled="showOnboardingTooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-bind="attrs"
              v-on="on"
            >
              <div
                class="d-flex flex-column justify-center text-caption font-weight-bold mr-1"
                style="line-height: 1.1;"
              >
                <div>DEEP</div>
                <div>DIVE</div>
              </div>
              <v-checkbox
                :input-value="deepDive"
                :color="COLORS.grainfoxAIButton"
                hide-details
                class="mt-0 pt-0"
                @change="toggleDeepDive"
              />
            </div>
          </template>
          <span class="white--text font-weight-bold">
            When you activate DEEP DIVE Sinoa will think longer to access richer, more comprehensive insights.
          </span>
        </v-tooltip>
      </GOnboardingTooltip>
    </div>
  </div>
</template>

<script>
import { COLORS } from '@/helpers/colors';
import { mapGetters, mapState, mapActions } from 'vuex';
import GOnboardingTooltip from '@/components/generic/GOnboardingTooltip.vue';

export default {
  name: 'SubscriptionChatUsage',

  components: {
    GOnboardingTooltip,
  },

  props: {
    fullScreen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      COLORS,
      showOnboardingTooltip: false,
    };
  },

  computed: {
    ...mapState('chatbot', ['chatUsage', 'showPaywall', 'deepDive']),
    ...mapState('launchDarkly', ['flags']),
    ...mapGetters('chatbot', ['isLimitReached']),

    autoRenewEnabled() {
      return this.chatUsage?.auto_renew;
    },

    questionsRemaining() {
      return this.chatUsage?.questions_remaining;
    },

    deepDiveEnabled() {
      return this.flags['sinoa-deep-dive'];
    },
  },

  mounted() {
    this.checkOnboardingTooltipDismissal();
    this.updateTooltipPosition();
  },

  watch: {
    fullScreen() {
      this.updateTooltipPosition();
    },
  },

  methods: {
    ...mapActions('chatbot', ['updateDeepDiveSettings']),

    toggleDeepDive(value) {
      this.updateDeepDiveSettings(value);
    },

    checkOnboardingTooltipDismissal() {
      const dismissedDate = localStorage.getItem('deepDive-tooltip-dismissed');
      const today = new Date().toISOString().split('T')[0];

      if (dismissedDate !== today) {
        this.showOnboardingTooltip = true;
      }
    },

    dismissOnboardingTooltip() {
      const today = new Date().toISOString().split('T')[0];
      localStorage.setItem('deepDive-tooltip-dismissed', today);
      this.showOnboardingTooltip = false;
    },

    tooltipStyle() {
      return 'z-index: 10000';
    },

    updateTooltipPosition() {
      const intervals = [0, 100, 300, 500];

      intervals.forEach((delay) => {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.onboardingTooltip) {
              this.$refs.onboardingTooltip.recomputeAnchorPosition();
              this.$refs.onboardingTooltip.recomputeContentSize();
            }
          }, delay);
        });
      });
    },
  },
};
</script>

<style scoped>
.v-tooltip__content {
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}

::v-deep .g-onboarding-tooltip__content {
  border-radius: 16px !important;
}
</style>
